import { EventHandler } from "@/utils/message.bus";
import { useToast } from "@/utils/useToast";
import { PropsWithChildren, useEffect } from "react";
import { TOAST_MESSAGE_BUS, ToastMessageBusEvent } from "./toast.consts";

export function ToastMessageBusHandler({ children }: PropsWithChildren) {
  const { showError, showToast } = useToast();

  useEffect(() => {
    const handler: EventHandler<ToastMessageBusEvent> = (event, ...args) => {
      if (event === "ERROR") {
        showError(args[0]);
        console.error("An error happened: ", args[0]);
      } else if (event === "REGULAR") {
        showToast(args[0], args[1]);
      }
    };

    TOAST_MESSAGE_BUS.subscribe("ERROR", handler);
    TOAST_MESSAGE_BUS.subscribe("REGULAR", handler);

    return () => {
      TOAST_MESSAGE_BUS.unsubscribe("ERROR", handler);
      TOAST_MESSAGE_BUS.unsubscribe("REGULAR", handler);
    };
  }, []);

  return children;
}
